function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Grid, Icon } from 'semantic-ui-react';
import rmrLogo from '../src/assets/images/logos/rmr_logo_0,25x.png';
import '../src/assets/css/index.css'; // import { findBySlug } from '../helpers';

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Footer.prototype.render = function render() {
    var _props = this.props,
        socialMedia = _props.socialMedia,
        contactUsLink = _props.contactUsLink,
        privacyPolicyLink = _props.privacyPolicyLink,
        refundPolicyLink = _props.refundPolicyLink,
        termsAndConditionsLink = _props.termsAndConditionsLink;
    var linkedInUrl = void 0;
    var twitterUrl = void 0;
    var facebookUrl = void 0; // TODO: Handle if these are not set.

    if (socialMedia && socialMedia.length > 0) {
      // $FlowFixMe
      linkedInUrl = findBySlug(socialMedia, 'LinkedIn', 'name').socialLink.url; // $FlowFixMe

      twitterUrl = findBySlug(socialMedia, 'Twitter', 'name').socialLink.url; // $FlowFixMe

      facebookUrl = findBySlug(socialMedia, 'Facebook', 'name').socialLink.url;
    } else {
      linkedInUrl = 'https://www.linkedin.com/company/roy-morgan/';
      twitterUrl = 'https://twitter.com/RoyMorganOnline';
      facebookUrl = 'https://www.facebook.com/RoyMorganResearch';
    }

    return React.createElement('div', null, React.createElement('div', {
      className: 'page-footer-container'
    }, React.createElement(Router, null, React.createElement('footer', {
      className: 'page-footer'
    }, React.createElement('div', {
      className: 'page-footer__top-row'
    }, React.createElement('div', {
      className: 'page-footer__social-links'
    }, React.createElement('a', {
      href: linkedInUrl,
      target: '_blank'
    }, React.createElement(Icon, {
      name: 'linkedin square'
    })), React.createElement('a', {
      href: twitterUrl,
      target: '_blank'
    }, React.createElement(Icon, {
      name: 'twitter'
    })), React.createElement('a', {
      href: facebookUrl,
      target: '_blank'
    }, React.createElement(Icon, {
      name: 'facebook official'
    }))), React.createElement('div', {
      className: contactUsLink && privacyPolicyLink && termsAndConditionsLink && termsAndConditionsLink ? "page-footer__links all-links" : "page-footer__links"
    }, React.createElement('a', {
      href: contactUsLink ? contactUsLink : "https://live.roymorgan.com/contact-us"
    }, 'Contact'), React.createElement('a', {
      href: privacyPolicyLink ? privacyPolicyLink : "https://live.roymorgan.com/privacy-policy"
    }, 'Privacy Policy'), termsAndConditionsLink && React.createElement('a', {
      href: termsAndConditionsLink
    }, 'Terms and Conditions'), refundPolicyLink && React.createElement('a', {
      href: refundPolicyLink
    }, 'Refund Policy')), React.createElement('div', {
      className: 'page-footer__logo-container'
    }, React.createElement('a', {
      href: 'http://roymorgan.com',
      target: '_blank'
    }, React.createElement('img', {
      className: 'page-footer__logo',
      src: this.props.footerLogo ? this.props.footerLogo : rmrLogo,
      alt: 'Roy Morgan'
    })))), React.createElement(Grid, {
      className: 'page-footer__addresses'
    }, React.createElement(Grid.Column, {
      tablet: 4,
      computer: 2
    }, React.createElement('h5', null, 'Melbourne'), React.createElement('p', null, 'Tonic House', React.createElement('br', null), '386 Flinders Lane,', React.createElement('br', null), 'Melbourne VIC, 3000')), React.createElement(Grid.Column, {
      tablet: 4,
      computer: 2
    }, React.createElement('h5', null, 'Sydney'), React.createElement('p', null, '484 Kent Street,', React.createElement('br', null), 'Sydney, NSW, 2000')))))));
  };

  return Footer;
}(React.Component);

export default Footer;